export default __webpack_public_path__ + "static/albert-f6586744e0722ab3125eac28694eb483.svg";